const nav = [
	{
		name: 'Home',
		path: 'home',
		color: 'bg-CeruleanBlue',
	},
	{
		name: 'About',
		path: 'about',
		color: 'bg-CaribbeanGreen',
	},
	/* {
		name: 'Education',
		path: '/education',
		color: 'CeruleanBlue',
	}, */
	{
		name: 'Projects',
		path: 'projects',
		color: 'bg-ButterCup',
	},
	{
		name: 'Contact',
		path: 'contact',
		color: 'bg-Trinidad',
	},
];

export default nav;